module.exports = __webpack_public_path__ + "static/media/home @1x.372cfd40.jpg";